import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom"; 
import { Maximize2 } from "lucide-react";        
import ShipmentNotification from "./NotificationTabContent/ShipmentNotification";
import InvoiceNotification from "./NotificationTabContent/InoiceNotification";


const NotificationDropdown = React.forwardRef(({ setUnreadCount }, ref) => {
  const [activeTab, setActiveTab] = useState("shipment");
  const dropdownRef = useRef(null);
  const navigate = useNavigate(); 

  const handleExpand = () => {
    setActiveTab(null); 
    navigate("/dashboard/notifications"); 
  };

//   useEffect(() => {
//     const token = Cookies.get("authToken");
//     const officeCode = Cookies.get("officeCode");
  
//     const fetchUnreadCount = async () => {
//       try {
//         const response = await axios.post(
//           `${process.env.REACT_APP_API_BASE_URL}/api/shipment-details/partial-search?page=0&size=5`,
//           { query: "" },
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Office-Code": officeCode,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const { content = [] } = response.data;
//         const unread = content.filter((s) => s.read === false).length;
//         setUnreadCount(unread); // <-- Set in parent
//       } catch (err) {
//         console.error("Unread fetch error:", err);
//         setUnreadCount(0);
//       }
//     };
  
//     fetchUnreadCount();
//   }, [setUnreadCount]);
  

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setActiveTab(null); // Close on outside click
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case "shipment":
        return <ShipmentNotification setNotificationCount={setUnreadCount} />;
      case "invoice":
        return <InvoiceNotification />;
      default:
        return null;
    }
  };

  return (
    <AnimatePresence>
      {activeTab && (
        <motion.div
          ref={dropdownRef}
          initial={{ opacity: 0, scale: 0.95, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.2 }}
          className="absolute right-0 mt-fluid-2 z-[400] bg-white shadow-xl rounded-2xl w-[clamp(26rem,32vw,30rem)] border border-gray-200 overflow-hidden"
        >
          {/* Header */}
          <div className="px-fluid-2 py-fluid-1.5 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h4 className="font-semibold text-fluid-base text-gray-800">Notifications</h4>
              <button className="text-fluid-xs text-blue-600 font-medium hover:underline">
                Mark all as read
              </button>
            </div>
            <div className="flex gap-fluid-1 mt-fluid-1">
              {[
                { label: "Shipments", value: "shipment" },
                { label: "Invoices", value: "invoice" }
              ].map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => setActiveTab(tab.value)}
                  className={`text-fluid-xs px-fluid-2 py-fluid-1 rounded-full border transition-all
                    ${activeTab === tab.value
                      ? "bg-[#e6e6f9] text-[#1e2a74] border-[#c7c7e6]"
                      : "text-gray-500 hover:bg-gray-100 border-transparent"}`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Dynamic Tab Content */}
          {renderContent()}

          {/* Expand Button (separate section) */}
          <div className="px-fluid-2 py-fluid-1.5 border-t border-gray-200 bg-white">
            <button
              onClick={handleExpand}
              className="flex items-center justify-end gap-1 text-blue-600 text-fluid-sm font-medium hover:underline"
            >
              <Maximize2 className="w-4 h-4" />
              Open Notification Center
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
});

export default NotificationDropdown;
